module.exports = __webpack_public_path__ + "static/media/rmfp.517733d5.png";